import React, { useState } from 'react';
import { FileDownIcon, MenuIcon, ClipboardIcon, BarChart2Icon, ActivityIcon, ShieldCheckIcon, UsersIcon } from 'lucide-react';
import { MobileNav } from './MobileNav';
interface HeaderProps {
  timeRange: string;
  setTimeRange: (range: string) => void;
}
export const Header: React.FC<HeaderProps> = () => {
  const [isMobileNavOpen, setIsMobileNavOpen] = useState(false);
  const [activeItem, setActiveItem] = useState('overview');
  const navItems = [{
    id: 'overview',
    label: 'Overview',
    icon: ClipboardIcon,
    section: 'overview',
    href: '#overview'
  }, {
    id: 'metrics',
    label: 'Metrics',
    icon: BarChart2Icon,
    section: 'metrics',
    href: '#metrics'
  }, {
    id: 'timeline',
    label: 'Timeline',
    icon: ActivityIcon,
    section: 'timeline',
    href: '#timeline'
  }, {
    id: 'proof',
    label: 'Proof',
    icon: ShieldCheckIcon,
    section: 'proof',
    href: '#proof'
  }, {
    id: 'audience',
    label: 'Audience',
    icon: UsersIcon,
    section: 'audience',
    href: '#audience'
  }];
  const handleExport = () => {
    window.print();
  };
  const scrollToSection = (sectionId: string) => {
    const element = document.getElementById(sectionId);
    if (element) {
      const headerOffset = 80;
      const elementPosition = element.getBoundingClientRect().top;
      const offsetPosition = elementPosition + window.pageYOffset - headerOffset;
      window.scrollTo({
        top: offsetPosition,
        behavior: 'smooth'
      });
    }
    setActiveItem(sectionId);
  };
  return <header className="bg-white border-b border-gray-100 sticky top-0 z-50 print:static print:border-b-0" data-id="element-424">
      <div className="container mx-auto px-4" data-id="element-425">
        <div className="flex items-center justify-between h-16 print:h-auto print:py-4" data-id="element-426">
          <div className="flex items-center" data-id="element-427">
            <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/caJJCtS3envvP8mN4NRUHS/Brandpulse_logo.png" alt="BrandPulse" className="h-6 w-auto" data-id="element-428" />
          </div>
          <nav className="hidden md:flex items-center space-x-1 print:hidden" data-id="element-429">
            {navItems.map(item => {
            const Icon = item.icon;
            return <a key={item.id} href={item.href} onClick={e => {
              e.preventDefault();
              scrollToSection(item.section);
            }} className={`flex items-center px-3 py-1.5 rounded-full text-sm transition-colors ${activeItem === item.section ? 'bg-[#1E90FF]/5 text-[#1E90FF]' : 'text-gray-600 hover:bg-gray-50'}`} data-id="element-430">
                  <Icon className="h-4 w-4 mr-2" data-id="element-431" />
                  {item.label}
                </a>;
          })}
          </nav>
          <div className="flex items-center space-x-2 print:hidden" data-id="element-432">
            <button onClick={handleExport} className="hidden md:flex items-center space-x-2 bg-white border border-[#1E90FF] text-[#1E90FF] px-4 py-2 rounded-lg font-medium hover:bg-[#1E90FF]/5 transition-colors" data-id="element-433">
              <FileDownIcon className="h-4 w-4" data-id="element-434" />
              <span data-id="element-435">Export</span>
            </button>

            <a href="https://create.brandpulse-analytics.com/" target="_blank" rel="noopener noreferrer" className="hidden md:block bg-[#1E90FF] text-white px-4 py-2 rounded-lg font-medium hover:bg-[#1E90FF]/90 transition-colors whitespace-nowrap" data-id="element-436">
              Create new
            </a>
            <button onClick={() => setIsMobileNavOpen(true)} className="md:hidden p-2 hover:bg-gray-50 rounded-full" data-id="element-437">
              <MenuIcon className="h-5 w-5 text-gray-600" data-id="element-438" />
            </button>
          </div>
        </div>
      </div>
      <MobileNav isOpen={isMobileNavOpen} onClose={() => setIsMobileNavOpen(false)} navItems={navItems} activeItem={activeItem} setActiveItem={id => {
      setActiveItem(id);
      scrollToSection(id);
    }} data-id="element-439" />
    </header>;
};